import { ColorEnum } from '@/constants/color'
import React, { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const BackArrowIcon: FC<SvgProps> = ({ color = ColorEnum.WHITE, ...props }) => {
    return (
        <Svg viewBox="0 0 24 24" width={24} height={24} fill="none" {...props}>
            <Path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.8}
                d="M9.396 14.695 4 9.345l5.396-5.35"
            />
            <Path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.8}
                d="M4.26 9.345h10.364c2.969 0 5.376 2.386 5.376 5.33s-2.407 5.33-5.376 5.33h-2.577"
            />
        </Svg>
    )
}

export default BackArrowIcon
